import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url } from '@/var/var.js'

Vue.use(VueAxios, axios)

Vue.mixin({
    methods: {
      RootOnly() {
        var ijin = true;
        if (sessionStorage.getItem('subAdminID') == 0) {
          ijin = true;
        } else {
          ijin = false;
        }
        
        return ijin;
      },
      getBulanNow() {
        return sessionStorage.getItem('bulanNamaBase');
      },
      getTahunNow() {
        return sessionStorage.getItem('tahunBase');
      },
      isAllow() {
        var allow;
        if (sessionStorage.getItem('level') == "0") {
          allow = true;
        } else {
          allow = false;
        }
        return allow;
      },
      sortAZ (datae,byWithUpperOrNot) {
        var data = datae;
        data.sort(function(a, b) {
          var by;
          if (byWithUpperOrNot.indexOf('-noUpperCase')) {
            var byIsArraySplit = byWithUpperOrNot.split('-');
            by = byIsArraySplit[0];
            if (!isNaN(parseInt(a[by]))) {
              if (true) {
                  return (parseInt(a[by]) > parseInt(b[by])) ? 1 : ((parseInt(a[by]) < parseInt(b[by]) ) ? -1 : 0);
              } else {
                  return (parseInt(b[by]) > parseInt(a[by]) ) ? 1 : ((parseInt(b[by]) < parseInt(a[by]) ) ? -1 : 0);
              }
            } else {
              if (true) {
                  return (a[by] > b[by]) ? 1 : ((a[by] < b[by]) ? -1 : 0);
              } else {
                  return (b[by] > a[by]) ? 1 : ((b[by] < a[by]) ? -1 : 0);
              }
            }
          } else {
            by = byWithUpperOrNot;
            if (!isNaN(parseInt(a[by]))) {
              if (true) {
                  return (parseInt(a[by]) > parseInt(b[by])) ? 1 : ((parseInt(a[by]) < parseInt(b[by]) ) ? -1 : 0);
              } else {
                  return (parseInt(b[by]) > parseInt(a[by]) ) ? 1 : ((parseInt(b[by]) < parseInt(a[by]) ) ? -1 : 0);
              }
            } else {
              if (true) {
                  return (a[by] > b[by].toUpperCase()) ? 1 : ((a[by] < b[by].toUpperCase()) ? -1 : 0);
              } else {
                  return (b[by] > a[by].toUpperCase()) ? 1 : ((b[by] < a[by].toUpperCase()) ? -1 : 0);
              }
            }
          }
        });
        return data;
      },
      sortZA (datae,byWithUpperOrNot) {
        var data = datae;
        data.sort(function(a, b) {
          /*
          var by;
          if (byIsArray.indexOf('-')) {
            var byIsArraySplit = byIsArray.split('-');
            if (Array.isArray(byIsArraySplit[0])) {
              console.log("yes array");
              by = byIsArraySplit[0][byIsArraySplit[1]];
            } else {
              by = byIsArraySplit[0]; // JIKA BUKAN ARRAY TERKONTAMINASI -
            }
          } else {
            by = byIsArray;
          }
          */
          var by;
          if (byWithUpperOrNot == "created_at") {
            by = byWithUpperOrNot;
            if (true) {
                return (b[by] > a[by]) ? 1 : ((b[by] < a[by]) ? -1 : 0);
            } else {
                return (a[by] > b[by]) ? 1 : ((a[by] < b[by]) ? -1 : 0);
            }
          } else {
            if (byWithUpperOrNot.indexOf('-noUpperCase')) {
              var byIsArraySplit = byWithUpperOrNot.split('-');
              by = byIsArraySplit[0];
              if (!isNaN(parseInt(a[by]))) {
                if (true) {
                    return (parseInt(b[by]) > parseInt(a[by]) ) ? 1 : ((parseInt(b[by]) < parseInt(a[by]) ) ? -1 : 0);
                } else {
                    return (parseInt(a[by]) > parseInt(b[by]) ) ? 1 : ((parseInt(a[by]) < parseInt(b[by]) ) ? -1 : 0);
                }
              } else {
                  if (true) {
                      return (b[by] > a[by]) ? 1 : ((b[by] < a[by]) ? -1 : 0);
                  } else {
                      return (a[by] > b[by]) ? 1 : ((a[by] < b[by]) ? -1 : 0);
                  }
              }
  
            } else {
              by = byWithUpperOrNot;
              if (!isNaN(parseInt(a[by]))) {
                    if (true) {
                        return (parseInt(b[by]) > parseInt(a[by]) ) ? 1 : ((parseInt(b[by]) < parseInt(a[by]) ) ? -1 : 0);
                    } else {
                        return (parseInt(a[by]) > parseInt(b[by]) ) ? 1 : ((parseInt(a[by]) < parseInt(b[by]) ) ? -1 : 0);
                    }
              } else {
                  if (true) {
                      return (b[by].toUpperCase() > a[by].toUpperCase()) ? 1 : ((b[by].toUpperCase() < a[by].toUpperCase()) ? -1 : 0);
                  } else {
                      return (a[by].toUpperCase() > b[by].toUpperCase()) ? 1 : ((a[by].toUpperCase() < b[by].toUpperCase()) ? -1 : 0);
                  }
              }
            }
          }
        });
        return data;
      },
      loger(x) {
        console.log(JSON.stringify(x));
      },
      ribu(x) {
        if (x == null) {
          return "Rp. 0";
        } else {
          return 'Rp. '+x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      },
      PostData(data,urlx) {
        var header = {'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': "application/json"
        };  

        return axios({
          method: "POST",
          url: url+"/"+urlx,
          headers: header, 
          data: data
        }).then((response) => {
            return response.data;
        })
        .catch(error => {
          var error = error.response;
          this.error(error);
        });            
        /*
        var header = {
            'Authorization': 'Bearer '+ sessionStorage.getItem('myToken'),
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json'
          };
  
        return axios({
          method: method,
          url: url + urlx,
          headers: header, 
          data: data
        }).then((response) => {
            return response.data;
        })
        .catch(error => {
          var error = error.response.status;
          this.error(error);
        });
        */
      },
      tglIndo(date) {      
        var bulan = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
        var tgl = new Date(date);
        var kosongJam;
        if (tgl.getHours()<10) {
            kosongJam = "0";
        } else {
            kosongJam = "";
        }
        var kosongMenit;
        if (tgl.getMinutes()<10) {
            kosongMenit = "0";
        } else {
            kosongMenit = "";
        }
        var realBulan = tgl.getDate()+' '+bulan[parseInt(tgl.getMonth())]+' '+tgl.getFullYear();
        
        
        return realBulan;
      }
    }
  })


// WEBPACK FOOTER //
// ./src/globalFunc/mixin.js